(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === 'object' && typeof module === 'object') module.exports = factory();else if (typeof define === 'function' && define.amd) define("JDate", [], factory);else if (typeof exports === 'object') exports["JDate"] = factory();else root["JDate"] = factory();
})(this, () => {
  return /******/(() => {
    // webpackBootstrap
    /******/
    var __webpack_modules__ = {
      /***/"./src/constants.js": (
      /*!**************************!*\
        !*** ./src/constants.js ***!
        \**************************/
      /***/
      module => {
        module.exports = {
          MONTH_NAMES: ['فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'امرداد', 'شهریور', 'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند'],
          ABBR_DAYS: ['۱ش', '۲ش', '۳ش', '۴ش', '۵ش', 'ج', 'ش'],
          DAYS_NAMES: ['یکشنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنج‌شنبه', 'جمعه', 'شنبه'],
          GREGORIAN_EPOCH: 1,
          GREGORIAN_TO_FIXED_OFFSET: 719528,
          PERSIAN_EPOCH: 226896,
          PERSIAN_CYCLE_DAYS: 12053,
          NON_LEAP_CORRECTION: [1502, 1601, 1634, 1667, 1700, 1733, 1766, 1799, 1832, 1865, 1898, 1931, 1964, 1997, 2030, 2059, 2063, 2096, 2129, 2158, 2162, 2191, 2195, 2224, 2228, 2257, 2261, 2290, 2294, 2323, 2327, 2356, 2360, 2389, 2393, 2422, 2426, 2455, 2459, 2488, 2492, 2521, 2525, 2554, 2558, 2587, 2591, 2620, 2624, 2653, 2657, 2686, 2690, 2719, 2723, 2748, 2752, 2756, 2781, 2785, 2789, 2818, 2822, 2847, 2851, 2855, 2880, 2884, 2888, 2913, 2917, 2921, 2946, 2950, 2954, 2979, 2983, 2987]
        };

        /***/
      }),
      /***/"./src/converter.js": (
      /*!**************************!*\
        !*** ./src/converter.js ***!
        \**************************/
      /***/
      (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"default": () => (/* binding */Converter)
          /* harmony export */
        });
        /* harmony import */
        var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./helpers */"./src/helpers.js");
        /* harmony import */
        var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./constants */"./src/constants.js");
        /* harmony import */
        var _constants__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_constants__WEBPACK_IMPORTED_MODULE_1__);
        function _typeof(o) {
          "@babel/helpers - typeof";

          return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
            return typeof o;
          } : function (o) {
            return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
          }, _typeof(o);
        }
        function _classCallCheck(a, n) {
          if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
        }
        function _defineProperties(e, r) {
          for (var t = 0; t < r.length; t++) {
            var o = r[t];
            o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
          }
        }
        function _createClass(e, r, t) {
          return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
            writable: !1
          }), e;
        }
        function _toPropertyKey(t) {
          var i = _toPrimitive(t, "string");
          return "symbol" == _typeof(i) ? i : i + "";
        }
        function _toPrimitive(t, r) {
          if ("object" != _typeof(t) || !t) return t;
          var e = t[Symbol.toPrimitive];
          if (void 0 !== e) {
            var i = e.call(t, r || "default");
            if ("object" != _typeof(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return ("string" === r ? String : Number)(t);
        }
        var Converter = /*#__PURE__*/function () {
          function Converter() {
            _classCallCheck(this, Converter);
          }
          return _createClass(Converter, null, [{
            key: "gregorianToFixed",
            value: function gregorianToFixed(year, month, day) {
              var result = _constants__WEBPACK_IMPORTED_MODULE_1__.GREGORIAN_EPOCH - 1 + 365 * (year - 1) + Math.floor((year - 1) / 4) - Math.floor((year - 1) / 100) + Math.floor((year - 1) / 400) + Math.floor((367 * month - 362) / 12)
              // eslint-disable-next-line no-nested-ternary
              + (month <= 2 ? 0 : Converter.leapGregorian(year) ? -1 : -2) + day;
              return result;
            }
          }, {
            key: "gregorianYearFromFixed",
            value: function gregorianYearFromFixed(date) {
              var d0 = date - _constants__WEBPACK_IMPORTED_MODULE_1__.GREGORIAN_EPOCH;
              var n400 = Math.floor(d0 / 146097);
              var d1 = d0 % 146097;
              var n100 = Math.floor(d1 / 36524);
              var d2 = d1 % 36524;
              var n4 = Math.floor(d2 / 1461);
              var d3 = d2 % 1461;
              var n1 = Math.floor(d3 / 365);
              var year = 400 * n400 + 100 * n100 + 4 * n4 + n1;
              if (n100 === 4 || n1 === 4) {
                return year;
              }
              return year + 1;
            }
          }, {
            key: "gregorianNewYear",
            value: function gregorianNewYear(year) {
              return Converter.gregorianToFixed(year, 1, 1);
            }
          }, {
            key: "fixedToGregorian",
            value: function fixedToGregorian(date) {
              var year = Converter.gregorianYearFromFixed(date);
              var priorDays = date - Converter.gregorianNewYear(year);
              var correction;
              if (date < Converter.gregorianToFixed([year, 3, 1])) {
                correction = 0;
              } else if (Converter.leapGregorian(year)) {
                correction = 1;
              } else {
                correction = 2;
              }
              var month = Math.floor((12 * (priorDays + correction) + 373) / 367);
              var day = date - Converter.gregorianToFixed(year, month, 1) + 1;
              return [year, month, day];
            }
          }, {
            key: "jalaliToFixed",
            value: function jalaliToFixed(year, month, day) {
              var newYear = _constants__WEBPACK_IMPORTED_MODULE_1__.PERSIAN_EPOCH - 1 + 365 * (year - 1) + Math.floor((8 * year + 21) / 33);
              if (_constants__WEBPACK_IMPORTED_MODULE_1__.NON_LEAP_CORRECTION.includes(year - 1)) {
                newYear -= 1;
              }
              return newYear - 1 + (month <= 7 ? 31 * (month - 1) : 30 * (month - 1) + 6) + day;
            }
          }, {
            key: "fixedToJalali",
            value: function fixedToJalali(fixedDate) {
              var daysSinceEpoch = fixedDate - Converter.jalaliToFixed(1, 1, 1);
              var year = 1 + Math.floor((33 * daysSinceEpoch + 3) / _constants__WEBPACK_IMPORTED_MODULE_1__.PERSIAN_CYCLE_DAYS);
              var dayOfYear = fixedDate - Converter.jalaliToFixed(year, 1, 1) + 1;
              if (dayOfYear === 366 && _constants__WEBPACK_IMPORTED_MODULE_1__.NON_LEAP_CORRECTION.includes(year)) {
                year += 1;
                dayOfYear = 1;
              }
              var month = dayOfYear <= 186 ? (0, _helpers__WEBPACK_IMPORTED_MODULE_0__.divCeil)(dayOfYear, 31) : (0, _helpers__WEBPACK_IMPORTED_MODULE_0__.divCeil)(dayOfYear - 6, 30);
              var day = fixedDate - Converter.jalaliToFixed(year, month, 1) + 1;
              return [year, month, day];
            }
          }, {
            key: "leapPersian",
            value: function leapPersian(jdate) {
              if (_constants__WEBPACK_IMPORTED_MODULE_1__.NON_LEAP_CORRECTION.includes(jdate)) {
                return false;
              }
              if (_constants__WEBPACK_IMPORTED_MODULE_1__.NON_LEAP_CORRECTION.includes(jdate - 1)) {
                return true;
              }
              return (25 * jdate + 11) % 33 < 8;
            }
          }, {
            key: "leapGregorian",
            value: function leapGregorian(year) {
              return year % 4 === 0 && ![100, 200, 300].includes(year % 400);
            }
          }]);
        }();

        /***/
      }),
      /***/"./src/helpers.js": (
      /*!************************!*\
        !*** ./src/helpers.js ***!
        \************************/
      /***/
      (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */divCeil: () => (/* binding */divCeil),
          /* harmony export */fixMonth: () => (/* binding */fixMonth),
          /* harmony export */replaceDay: () => (/* binding */replaceDay),
          /* harmony export */replaceMonth: () => (/* binding */replaceMonth),
          /* harmony export */replaceYear: () => (/* binding */replaceYear),
          /* harmony export */zeroLeading: () => (/* binding */zeroLeading)
          /* harmony export */
        });
        /* harmony import */
        var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./constants */"./src/constants.js");
        /* harmony import */
        var _constants__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_constants__WEBPACK_IMPORTED_MODULE_0__);
        /* eslint-disable no-unused-vars */

        function divCeil(a, b) {
          return Math.floor((a + b - 1) / b);
        }
        function fixMonth(year, month) {
          if (month > 12 || month <= 0) {
            var yearDiff = Math.floor((month - 1) / 12);
            var newYear = year - yearDiff;
            var newMonth = month - yearDiff * 12;
            return [newYear, newMonth];
          }
          return [year, month];
        }
        function zeroLeading(str) {
          if (str && str.length === 1) {
            return "0".concat(str);
          }
          return str;
        }
        function replaceYear(str, date) {
          var match = str.match(/[yY]+/);
          if (!match) {
            return str;
          }
          switch (match[0]) {
            case 'YYYY':
            case 'YYY':
              {
                var value = replaceYear(str.replace(match, date.getFullYear()), date);
                return value;
              }
            case 'YY':
              {
                var _value = replaceYear(str.replace(match, String(date.getFullYear()).slice(2)), date);
                return _value;
              }
            default:
              {
                return str;
              }
          }
        }
        function replaceMonth(str, date) {
          var match = str.match(/[mM]+/);
          if (!match) {
            return str;
          }
          switch (match[0]) {
            case 'M':
              {
                var value = replaceMonth(str.replace(match, date.getMonth()), date);
                return value;
              }
            case 'MM':
              {
                var zeroLeadingMonth = zeroLeading(date.getMonth().toString());
                var _value2 = replaceMonth(str.replace(match, zeroLeadingMonth), date);
                return _value2;
              }
            case 'MMM':
            case 'MMMM':
              {
                var _value3 = replaceMonth(str.replace(match, _constants__WEBPACK_IMPORTED_MODULE_0__.MONTH_NAMES[date.getMonth() - 1]), date);
                return _value3;
              }
            default:
              {
                return str;
              }
          }
        }
        function replaceDay(str, date) {
          var match = str.match(/[dD]+/);
          if (!match) {
            return str;
          }
          switch (match[0]) {
            case 'D':
              {
                var value = replaceDay(str.replace(match, date.getDate()), date);
                return value;
              }
            case 'DD':
              {
                var zeroLeadingDate = zeroLeading(date.getDate().toString());
                var _value4 = replaceDay(str.replace(match, zeroLeadingDate), date);
                return _value4;
              }
            case 'd':
            case 'dd':
              {
                var _value5 = replaceDay(str.replace(match, _constants__WEBPACK_IMPORTED_MODULE_0__.ABBR_DAYS[date.getDay()]), date);
                return _value5;
              }
            case 'ddd':
            case 'dddd':
              {
                var _value6 = replaceDay(str.replace(match, _constants__WEBPACK_IMPORTED_MODULE_0__.DAYS_NAMES[date.getDay()]), date);
                return _value6;
              }
            default:
              {
                return str;
              }
          }
        }

        /***/
      })

      /******/
    };
    /************************************************************************/
    /******/ // The module cache
    /******/
    var __webpack_module_cache__ = {};
    /******/
    /******/ // The require function
    /******/
    function __webpack_require__(moduleId) {
      /******/ // Check if module is in cache
      /******/var cachedModule = __webpack_module_cache__[moduleId];
      /******/
      if (cachedModule !== undefined) {
        /******/return cachedModule.exports;
        /******/
      }
      /******/ // Create a new module (and put it into the cache)
      /******/
      var module = __webpack_module_cache__[moduleId] = {
        /******/ // no module.id needed
        /******/ // no module.loaded needed
        /******/exports: {}
        /******/
      };
      /******/
      /******/ // Execute the module function
      /******/
      __webpack_modules__[moduleId](module, module.exports, __webpack_require__);
      /******/
      /******/ // Return the exports of the module
      /******/
      return module.exports;
      /******/
    }
    /******/
    /************************************************************************/
    /******/ /* webpack/runtime/compat get default export */
    /******/
    (() => {
      /******/ // getDefaultExport function for compatibility with non-harmony modules
      /******/__webpack_require__.n = module => {
        /******/var getter = module && module.__esModule ? /******/() => module['default'] : /******/() => module;
        /******/
        __webpack_require__.d(getter, {
          a: getter
        });
        /******/
        return getter;
        /******/
      };
      /******/
    })();
    /******/
    /******/ /* webpack/runtime/define property getters */
    /******/
    (() => {
      /******/ // define getter functions for harmony exports
      /******/__webpack_require__.d = (exports, definition) => {
        /******/for (var key in definition) {
          /******/if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
            /******/Object.defineProperty(exports, key, {
              enumerable: true,
              get: definition[key]
            });
            /******/
          }
          /******/
        }
        /******/
      };
      /******/
    })();
    /******/
    /******/ /* webpack/runtime/hasOwnProperty shorthand */
    /******/
    (() => {
      /******/__webpack_require__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
      /******/
    })();
    /******/
    /******/ /* webpack/runtime/make namespace object */
    /******/
    (() => {
      /******/ // define __esModule on exports
      /******/__webpack_require__.r = exports => {
        /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
          /******/Object.defineProperty(exports, Symbol.toStringTag, {
            value: 'Module'
          });
          /******/
        }
        /******/
        Object.defineProperty(exports, '__esModule', {
          value: true
        });
        /******/
      };
      /******/
    })();
    /******/
    /************************************************************************/
    var __webpack_exports__ = {};
    // This entry need to be wrapped in an IIFE because it need to be in strict mode.
    (() => {
      "use strict";

      /*!**********************!*\
        !*** ./src/jdate.js ***!
        \**********************/
      __webpack_require__.r(__webpack_exports__);
      /* harmony export */
      __webpack_require__.d(__webpack_exports__, {
        /* harmony export */"default": () => (/* binding */JDate)
        /* harmony export */
      });
      /* harmony import */
      var _converter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./converter */"./src/converter.js");
      /* harmony import */
      var _helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./helpers */"./src/helpers.js");
      function _typeof(o) {
        "@babel/helpers - typeof";

        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
          return typeof o;
        } : function (o) {
          return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
        }, _typeof(o);
      }
      function _slicedToArray(r, e) {
        return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
      }
      function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }
      function _unsupportedIterableToArray(r, a) {
        if (r) {
          if ("string" == typeof r) return _arrayLikeToArray(r, a);
          var t = {}.toString.call(r).slice(8, -1);
          return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
        }
      }
      function _arrayLikeToArray(r, a) {
        (null == a || a > r.length) && (a = r.length);
        for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
        return n;
      }
      function _iterableToArrayLimit(r, l) {
        var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
        if (null != t) {
          var e,
            n,
            i,
            u,
            a = [],
            f = !0,
            o = !1;
          try {
            if (i = (t = t.call(r)).next, 0 === l) {
              if (Object(t) !== t) return;
              f = !1;
            } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
          } catch (r) {
            o = !0, n = r;
          } finally {
            try {
              if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally {
              if (o) throw n;
            }
          }
          return a;
        }
      }
      function _arrayWithHoles(r) {
        if (Array.isArray(r)) return r;
      }
      function _classCallCheck(a, n) {
        if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
      }
      function _defineProperties(e, r) {
        for (var t = 0; t < r.length; t++) {
          var o = r[t];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
        }
      }
      function _createClass(e, r, t) {
        return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }
      function _toPropertyKey(t) {
        var i = _toPrimitive(t, "string");
        return "symbol" == _typeof(i) ? i : i + "";
      }
      function _toPrimitive(t, r) {
        if ("object" != _typeof(t) || !t) return t;
        var e = t[Symbol.toPrimitive];
        if (void 0 !== e) {
          var i = e.call(t, r || "default");
          if ("object" != _typeof(i)) return i;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return ("string" === r ? String : Number)(t);
      }
      /*
       * https://github.com/arashm/JDate
       * @author: Arash Mousavi
       */

      var JDate = /*#__PURE__*/function () {
        function JDate() {
          _classCallCheck(this, JDate);
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          if (Array.isArray(args[0]) || args[0] instanceof Date) {
            this.input = args[0];
          } else if (args.length === 3) {
            this.input = args;
          } else if (!args.length) {
            this.input = new Date();
          } else {
            throw new Error('Unexpected input');
          }
          if (Array.isArray(this.input)) {
            this.date = this.input.map(function (num) {
              return parseInt(num, 10);
            });
            this._d = this.toGregorian();
          } else if (this.input instanceof Date) {
            this._d = this.input;
            this.date = JDate.toJalali(this.input);
          }
        }

        /*
         * Coverts a Gregorian date to Jalali date
         *
         * @params {Date} date
         * @return {Array}
         */
        return _createClass(JDate, [{
          key: "toGregorian",
          value:
          /*
           * Converts JDate date to Gregorian
           */
          function toGregorian() {
            return JDate.toGregorian(this.date[0], this.date[1], this.date[2]);
          }

          /*
           * Shows Jalali's full year, ex: 1393
           *
           * @return {Integer}
           */
        }, {
          key: "getFullYear",
          value: function getFullYear() {
            return this.date[0];
          }

          /*
           * Sets the Jalali full year
           *
           * @params {Number} year
           * @return {JDate}
           */
        }, {
          key: "setFullYear",
          value: function setFullYear(year) {
            this.date[0] = parseInt(year, 10);
            this.input = this.toGregorian();
            return this;
          }

          /*
           * Shows Jalali month number.
           *
           * @return {Number} Jalali month number
           */
        }, {
          key: "getMonth",
          value: function getMonth() {
            return this.date[1];
          }

          /*
           * Sets the Jalali month number. An integer between 0 and 11
           *
           * @params {Number} month
           * @returns {JDate}
           */
        }, {
          key: "setMonth",
          value: function setMonth(month) {
            var fixed = _helpers__WEBPACK_IMPORTED_MODULE_1__.fixMonth(this.getFullYear(), parseInt(month, 10));
            var _fixed = _slicedToArray(fixed, 2);
            this.date[0] = _fixed[0];
            this.date[1] = _fixed[1];
            this.input = this.toGregorian();
            return this;
          }

          /*
           * Shows Jalali day number. A number between 0 to 31
           *
           * @return {Number} Jalali day number
           */
        }, {
          key: "getDate",
          value: function getDate() {
            return this.date[2];
          }

          /*
           * Sets Jalali day number. A number between 0 to 31
           *
           * @params {Number} date
           * @return {JDate}
           */
        }, {
          key: "setDate",
          value: function setDate(date) {
            this.date[2] = parseInt(date, 10);
            this.input = this.toGregorian();
            return this;
          }

          /*
           * Returns the day of the week for the specified date. A number between 0 to 6
           *
           * @returns {Number}
           */
        }, {
          key: "getDay",
          value: function getDay() {
            return this._d.getDay();
          }

          /*
           * Returns a formated output of current date
           *
           * @params {String} format
           * @return {String}
           */
        }, {
          key: "format",
          value: function format(_format) {
            var result = _helpers__WEBPACK_IMPORTED_MODULE_1__.replaceYear(_format, this);
            result = _helpers__WEBPACK_IMPORTED_MODULE_1__.replaceMonth(result, this);
            result = _helpers__WEBPACK_IMPORTED_MODULE_1__.replaceDay(result, this);
            return result;
          }
        }], [{
          key: "toJalali",
          value: function toJalali(date) {
            var fixedDate = _converter__WEBPACK_IMPORTED_MODULE_0__["default"].gregorianToFixed(date.getFullYear(), date.getMonth() + 1, date.getDate());
            var jdate = _converter__WEBPACK_IMPORTED_MODULE_0__["default"].fixedToJalali(fixedDate);
            return jdate;
          }

          // eslint-disable-next-line camelcase
        }, {
          key: "to_jalali",
          value: function to_jalali(date) {
            return JDate.toJalali(date);
          }

          /*
           * converts a Jalali date to Gregorian
           *
           * @params {Number} year
           * @params {Number} month
           * @params {Number} day
           * @return {Date}
           */
        }, {
          key: "toGregorian",
          value: function toGregorian(year, month, day) {
            var gdate = _converter__WEBPACK_IMPORTED_MODULE_0__["default"].fixedToGregorian(_converter__WEBPACK_IMPORTED_MODULE_0__["default"].jalaliToFixed(year, month, day));
            return new Date(+gdate[0], +gdate[1] - 1, +gdate[2]);
          }

          // eslint-disable-next-line camelcase
        }, {
          key: "to_gregorian",
          value: function to_gregorian(year, month, day) {
            return JDate.toGregorian(year, month, day);
          }

          /*
           * Checks if a given year is a leap year or not
           *
           * @params {Number} year
           * @return {Boolean}
           */
        }, {
          key: "isLeapYear",
          value: function isLeapYear(year) {
            return _converter__WEBPACK_IMPORTED_MODULE_0__["default"].leapPersian(year);
          }

          /*
           * Returns month length.
           *
           * @params {Number} year
           * @params {Number} month zero based
           * @return {Number}
           */
        }, {
          key: "daysInMonth",
          value: function daysInMonth(year, month) {
            var calcedYear = year - Math.floor(month / 12);
            var calcedMonth = month - Math.floor(month / 12) * 12;
            if (calcedMonth < 0) {
              calcedMonth += 12;
              calcedYear -= 1;
            } else if (calcedMonth === 0) {
              calcedMonth = 12;
            }
            if (calcedMonth < 6) {
              return 31;
            }
            if (calcedMonth < 11) {
              return 30;
            }
            if (JDate.isLeapYear(calcedYear)) {
              return 30;
            }
            return 29;
          }
        }]);
      }();
    })();
    __webpack_exports__ = __webpack_exports__["default"];
    /******/
    return __webpack_exports__;
    /******/
  })();
});